<template>
    <input
        v-if="loaded"
        :value="decimalValue"
        @input="updateValue($event.target.value)"
        type="number"
    />
</template>

<script>
import currencyService from '../../services/currency.service';

export default {
    name: 'currency-input',
    props: {
        value: true,
        currency: {
            type: String,
            required: true
        },
        set: {
            type: Function,
            required: false,
            default: () => {}
        }
    },
    data() {
        return {
            loaded: false
        }
    },
    computed: {
        decimalValue() {
            return currencyService.fromSource(this.value || 0, this.currency);
        }
    },
    async created() {
        await currencyService.ensure();
        this.loaded = true;
    },
    methods: {
        updateValue: function(value) {
            var longValue = currencyService.toSource(value || 0, this.currency);
            this.set(longValue);
        }
    }
};
</script>


// WEBPACK FOOTER //
// front/src/components/common/currency-input.vue